import styled from '@emotion/styled'
import {theme} from '../theme'

export const PageWrapper = styled.div`
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  min-height: 100%;
  width: 100%;
  // background: ${theme.palette.thryv.bg};
  padding: 10px;
  gap: 16px;
`

export const PageHeader = styled.div`
  // padding: ${theme.space[4]} ${theme.space[4]} 0;
  // padding: 10px;
  // background: ${theme.palette.thryv.bg};
  background: ${theme.palette.neutral[0]}
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: ${theme.space[1]};
`

export const PageTitle = styled.h1`
  font-size: ${theme.fontSizes['3xl']};
  font-weight: ${theme.fontWeights.bold};
  color: ${theme.colors.text.primary};
  margin: 0 0 ${theme.space[1]};
`

export const PageSubtitle = styled.p`
  font-size: ${theme.fontSizes.md};
  color: ${theme.colors.text.primary};
  margin: 0;
`

export const ContentArea = styled.main`
  // flex: 1;
  // display: flex;
  // justify-content: center;
  //   flex-direction: column;
  //   align-items: center;
  // padding: ${theme.space[2]};
  width: 100%;
  // // background: #f4f6fb;
`
